/**
 * Auto-generated offer lifecycle texts stored as chat messages (legacy + older APIs).
 * Threads render offer state via offer cards only — hide these duplicates.
 */
export function isRedundantOfferConversationText(text) {
  const t = (text || "").trim();
  if (!t) return false;
  return (
    t.startsWith("Made an offer of ") ||
    t.startsWith("Made a bundle offer of ") ||
    t.startsWith("Buyer countered back:") ||
    t.startsWith("Buyer accepted counter offer!") ||
    t.startsWith("Offer accepted! Final price:") ||
    t === "Offer rejected" ||
    t.startsWith("Counter offer:")
  );
}
